export const publicNavigation = [
  { to: '/#about', label: 'ui.about' }, { to: '/#services', label: 'ui.services' },
  { to: '/#choose', label: 'ui.whyChoose' }, { to: '/book', label: 'ui.tracking' }, { to: '/#contact', label: 'ui.contact' }
];
export const portalNavigation = [
  { to: '/profile', label: 'ui.profile', icon: 'user' },
  { to: '/booking', label: 'ui.bookings', icon: 'box' },
  { to: '/employee', label: 'ui.employees', icon: 'users', hideForEmployee: true },
  { to: '/password', label: 'ui.password', icon: 'lock' }
];
